import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
// import clsx from 'clsx';
import _ from 'lodash';

import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
// import DialogTitle from '@material-ui/core/DialogTitle'; // substituted by custom
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
// import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
// import EditIcon from '@material-ui/icons/Edit';
import SaveIcon from '@material-ui/icons/Save';
import PhotoCamera from '@material-ui/icons/PhotoCamera';

import DialogTitle from 'components/DialogTitle';
import { editDebate, saveDebateImage } from '../store/debates.slice';
import { openDialog, closeDialog } from '../store/discuss.slice';

const useStyles = makeStyles(theme => ({
  root: {
    // border: 'solid black 1px', // DEBUG
  },
}));

function DebateImageEdit(props) {
  const {
    show,
    debate,
    // pending,
    // error,
    openDialog,
    onOpen,
    onClose,
    onSave,
  } = props;
  const classes = useStyles();
  const [values, setValues] = useState(null);

  function handleChange(event) {
    const { name, value, files } = event.target;
    const _value = _.isEmpty(files) ? value : files[0];
    setValues({ ...values, [name]: _value });
  }

  const handleSave = (event) => {
    event.preventDefault();
    onSave(values);
  };

  const buildTrigger = () => (
    <IconButton
      size="small"
      aria-label="Edit debate image"
      onClick={onOpen}
    >
      Edit
    </IconButton>
  );

  const buildForm = () => (<>

  </>);

  const buildActions = () => (<>
    <Button
      variant="contained"
      size="small"
      onClick={onClose}
    >Cancel</Button>
    <Button
      variant="contained"
      color="secondary"
      size="small"
      // className={classes.button}
      startIcon={<SaveIcon />}
      onClick={handleSave}
    >Save</Button>
  </>);

  useEffect(() => {
    if (debate) {
      setValues(debate);
    }
  }, [debate]);

  // console.log('DebateDimensionsCast', props); // DEBUG

  return (
    <div className={classes.root}>
      {show && buildTrigger()}
      <Dialog
        open={openDialog}
        // maxWidth="md"
        fullWidth={true}
        onClose={onClose}
      >
        <DialogTitle onClose={onClose}>Edit debate</DialogTitle>
        <DialogContent>
          {buildForm()}
        </DialogContent>
        <DialogActions>
          {buildActions()}
        </DialogActions>
      </Dialog>
    </div>
  );
}

const mapStateToProps = (state, ownProps) => {
  const debate = ownProps.debate;
  const dialogState = state.discuss.layout.dialogs;
  // const authUser = state.auth.profile;
  const uid = _.get(state.auth.profile, 'uid', false);
  return {
    openDialog: dialogState.debateImageEdit === debate.id,
    show: uid === debate.metadata.createdBy
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const debate = ownProps.debate;
  return {
    onSave: values => {
      console.log('@todo')
      // return dispatch(editDebate(values))
      //   .then(res => {
      //     if (res.meta.requestStatus === 'fulfilled') {
      //       dispatch(closeDialog('debateImageEdit'));
      //     }
      //     return res;
      //   });
    },
    onOpen: () => dispatch(openDialog({
      resourceName: 'debateImageEdit',
      resourceId: debate.id,
    })),
    onClose: () => dispatch(closeDialog('debateImageEdit')),
  }
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DebateImageEdit);
